import React from "react";

import Joi from "joi-browser";
import Form from "../common/Form";

import db from "../../services/query";
import lbl from "../../data/Labels.json";

import { PopUpContext } from "../../contexts/popUpContext";

class ClassForm extends Form {
  static contextType = PopUpContext;

  state = {
    drp: {
      time: [],
      department: [],
      faculty: [],
      entry_year: [],
      class_status: [],
    },
    data: {
      class_desc: "",
      class_desc_en: "",
      time: "",
      department: "",
      faculty: "",
      entry_year: "",
      class_status: "",
      meet_link: "",
      drive_link: "",
    },
    errors: {},
  };

  componentDidMount = async () => {
    const { drp, data } = this.state;

    const {
      popUp: { edit },
    } = this.context;

    if (edit) {
      data.class_desc = edit.class_desc;
      data.class_desc_en = edit.class_desc_en;
      data.time = edit.time_id;
      data.department = edit.department_id;
      data.faculty = edit.faculty_id;
      data.entry_year = edit.entry_year_id;
      data.class_status = edit.class_status_id;
      data.meet_link = edit.meet_link;
      data.drive_link = edit.drive_link;
    }

    await db
      .getAll(`dropdowns/departments`)
      .then(({ data: { data } }) => (drp["department"] = data));

    await db
      .getAll(`dropdowns/faculties`)
      .then(({ data: { data } }) => (drp["faculty"] = data));

    await db
      .getAll(`dropdowns/entryYears`)
      .then(({ data: { data } }) => (drp["entry_year"] = data));

    await db
      .getAll(`dropdowns/times`)
      .then(({ data: { data } }) => (drp["time"] = data));

    await db
      .getAll(`dropdowns/classStatus`)
      .then(({ data: { data } }) => (drp["class_status"] = data));

    this.setState({ drp, data });
  };

  schema = {
    class_desc: Joi.string().max(32).required(),
    class_desc_en: Joi.string().max(32).required(),
    time: Joi.number().required(),
    department: Joi.number().allow(null).allow(""),
    faculty: Joi.number().required(),
    entry_year: Joi.number().required(),
    class_status: Joi.number().required(),
    meet_link: Joi.string().max(256).allow("").allow(null),
    drive_link: Joi.string().max(256).allow("").allow(null),
  };

  doSubmit = async () => {
    try {
      const { togglePopUp, popUp } = this.context;

      const __controls = this.cleanObject({
        ...this.state.data,
      });

      if (popUp?.edit) {
        await db
          .edit(`classes/${popUp?.edit?.class_id}`, __controls)
          .then(() => {
            togglePopUp({ form: "toast" });
          })
          .catch((err) => {
            togglePopUp({
              form: "toast",
              message: err.toString(),
              type: "warning",
            });
          });
      } else {
        await db
          .save("classes", __controls)
          .then(() => {
            togglePopUp({ form: "toast" });
          })
          .catch((err) => {
            togglePopUp({
              form: "toast",
              message: err.toString(),
              type: "warning",
            });
          });
      }
    } catch ({ response }) {
      if (response && response.status === 400) {
        const errors = { ...this.state.error };

        this.setState({ errors });
      }
    }
  };

  render() {
    const { drp } = this.state;
    const { popUp } = this.context;

    return (
      <div className="form-container">
        <form className="form crud" onSubmit={this.handleSubmit}>
          <div className="head">
            <p>{popUp?.edit ? lbl.EditClass : lbl.AddClass}</p>
          </div>
          <div className="form-inputs">
            <div className="multi-input">
              {this.renderInput("class_desc", "نام (فارسی)")}
              {this.renderInput("class_desc_en", "نام (انگلیسی)")}
            </div>
            <div className="multi-input">
              {this.renderSelect("faculty", "پوهنحی", drp.faculty)}
              {this.renderSelect("department", "دیپارتمنت", drp.department)}
            </div>
            <div className="multi-input">
              {this.renderSelect("time", "نوبت", drp.time)}
              {this.renderSelect("class_status", "وضعیت", drp.class_status)}
            </div>
            {this.renderSelect("entry_year", "سال", drp.entry_year)}
            {this.renderInput("meet_link", "لینک (Google Meet)", "url")}
            {this.renderInput("drive_link", "لینک (Google Drive)", "url")}
          </div>
          <div className="form-buttons">
            {this.renderButton(popUp?.edit ? lbl.Edit : lbl.Save)}
          </div>
        </form>
      </div>
    );
  }
}

export default ClassForm;
